/****************************************************************
 * File: customer-words-card.tsx
 * Description: 展示用好的话的卡片
 * Author: zayfen <zhangyunfeng@pudutech.com>
 * Created: 2022/05/26 11:24
 *
 * History:
 *   Date               Programmer ID    Description
 *  -----------------  ---------------  ------------------------
 *  2022/05/26 11:24   zayfen           Init
 *
 * This unpublished material is proprietary to PuduTech.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of PuduTech.
 *****************************************************************/

import { FC } from 'react'
import PdImage from '../pd-image/pd-image'

export interface TestimonialsProps {
  className?: string
  avator: string
  imageAlt?: string
  name: string
  jobTitle: string
  words: string
  style?: 'row' | 'col'
}

// Testimonials
const Testimonials: FC<TestimonialsProps> = ({ avator, imageAlt, name, jobTitle, words, style, className }) => {
  return (
    <article
      className={[
        'TestimonialsCard',
        'relative flex  bg-white',
        !style ? 'flex-col w-270px p-18px laptop:w-90 laptop:p-6' : '',
        style === 'row' ? 'flex-row w-full' : '',
        style === 'col' ? 'flex-col w-full' : '',
        className ? className : '',
      ].join(' ')}
    >
      <div
        className={[
          !style ? 'w-full h-40 laptop:h-50' : '',
          style === 'row' ? 'laptop:h-51 laptop:w-312px flex-none' : '',
          style === 'col' ? 'w-full h-214px' : '',
        ].join(' ')}
      >
        <PdImage src={avator} alt={imageAlt} enableMask={false} object="cover" width={'100%'} height={'100%'} />
      </div>
      <div className={style === 'row' ? 'ml-6' : ''}>
        <header>
          <h3
            className={['mt-3 text-lg', 'laptop:mt-4 text-2xl', 'font-semibold text-black/90 line-clamp-2'].join(' ')}
          >
            {name}
          </h3>
          <p className={['mt-1', 'laptop:mt-2', 'text-sm text-black/60 line-clamp-2'].join(' ')}>{jobTitle}</p>
        </header>

        <p
          className={['mt-4 leading-normal', 'laptop:mt-6 laptop:leading-6', 'relative text-sm text-black/90'].join(
            ' '
          )}
        >
          <q>{words}</q>
        </p>
      </div>
    </article>
  )
}

export default Testimonials
